import { createRoutine } from "../utils/routine.utils";
export var getDeleteAction = function (params) {
    var entityName = params.entityName;
    return createRoutine("".concat(entityName, "_DELETE").toUpperCase());
};
